/**
 * One fixed hue per stage.
 *
 * Stage is the second-strongest signal in the day list after the artist name, so it
 * gets a stable colour a regular user can learn. Used only on the small stage tag —
 * never behind text.
 */
const STAGE_VARIABLES: Record<string, string> = {
  Amfiet: '--stage-amfiet',
  Sirkus: '--stage-sirkus',
  Vindfruen: '--stage-vindfruen',
  'Hagen til Stø': '--stage-hagen',
  Klubben: '--stage-klubben',
  Biblioteket: '--stage-biblioteket',
}

export function stageColor(stage: string): string {
  return `var(${STAGE_VARIABLES[stage] ?? '--stage-default'})`
}
